import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=20107e6e&scoped=true&"
import script from "./Popup.vue?vue&type=script&lang=js&"
export * from "./Popup.vue?vue&type=script&lang=js&"
import style0 from "./Popup.vue?vue&type=style&index=0&id=20107e6e&prod&scoped=true&lang=scss&"
import style1 from "./Popup.vue?vue&type=style&index=1&id=20107e6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20107e6e",
  null
  
)

export default component.exports